import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as SvgIcons from './iconsFolder';

export type svgIcons = keyof typeof SvgIcons;
type IconsProps = {
  name: svgIcons;
} & SvgIconProps;

const Icon = (props: IconsProps) => {
  const { name, ...rest } = props;
  // Use a function to get the icon to avoid dynamic namespace access warning
  const getSvgIcon = (iconName: svgIcons) => {
    const icons = SvgIcons as Record<string, any>;
    return icons[iconName];
  };
  const Svg = getSvgIcon(name);
  return (
    <SvgIcon {...rest}>
      <Svg {...rest} />
    </SvgIcon>
  );
};
export default Icon;
